import { render, staticRenderFns } from "./FacultyLeaveReport.vue?vue&type=template&id=7154ff98"
import script from "./FacultyLeaveReport.vue?vue&type=script&lang=js"
export * from "./FacultyLeaveReport.vue?vue&type=script&lang=js"
import style0 from "./FacultyLeaveReport.vue?vue&type=style&index=0&id=7154ff98&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports